import React, { useEffect, useState } from "react";

import { ButtonGroup } from "@mui/material";

import Button from "react-bootstrap/Button";

import styles from "./roleManagementItem.module.css";
import { useSelector } from "react-redux";
import useChapterActionIdMatch from "../../../../hooks/useChapterActionIdMatch";

const RoleManagementItem = ({ item, chaptersByRole, onUpdateItem, handleTextClick }) => {
  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const editAccess = useChapterActionIdMatch(sortedMenuNames?.ROLE_MANAGMENT?.editingARole?.chapterActionId);
  const handleButtonClick = (value) => {
    // if(editAccess){
    onUpdateItem(item, value);
    // }
  };

  const itemCheck = () => {
    const isItemAuthorized = chaptersByRole.some((chapter) => {
      return chapter.chapterId === item.id && chapter.privValue === true;
    });

    if (isItemAuthorized) {
      return true;
    } else {
      return false;
    }
  };

  const onClickText = () => {
    if (itemCheck() && editAccess) {
      handleTextClick(item, true);
    } else {
      handleTextClick(item, false);
    }
  };

  return (
    <div className={styles["role-item"]}>
      <div
        disabled={!editAccess}
        onClick={onClickText}
        className={styles["column"]}>
        <label
          className={styles["label"]}
          disabled={!editAccess}>
          {item.name}
        </label>
      </div>
      <div className={`${styles["column-buttons"]}  ${styles["button"]}`}>
        <ButtonGroup
          className={styles["buttons"]}
          color="primary"
          aria-label="outlined primary button group">
          <Button
            className={`${!editAccess ? styles["disabled-button"] : ""} ${
              itemCheck() ? styles["button-selected"] : styles["button-not-selected"]
            } `}
            disabled={!editAccess}
            onClick={() => handleButtonClick(true)}>
            Да
          </Button>
          <Button
            className={` ${!editAccess ? styles["disabled-button"] : ""} ${
              !itemCheck() ? styles["button-selected"] : styles["button-not-selected"]
            }`}
            disabled={!editAccess}
            onClick={() => handleButtonClick(false)}>
            Нет
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
};

export default RoleManagementItem;
